import React from "react";
import "./sub-header.css";
import { MdEmail, MdWifiCalling3 } from "react-icons/md";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { IoLocation } from "react-icons/io5";

let SubHeader = () => {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  return (
    <div className="sub-header-main">
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item lg={1} sm={1}></Grid>
          <Grid item lg={8} sm={6}>
            <div className="sub-header-data-main">
              <div className="sub-header-email-main">
                <MdEmail color="#fff" size={24} />
                <p className="sub-header-data">Support@amafclasses.com</p>
              </div>
              <div className="sub-header-mobile-number">
                <MdWifiCalling3 color="#fff" size={24} />
                <p className="sub-header-data">+971 1 2345678</p>
              </div>
            </div>
          </Grid>
          <Grid item lg={3} sm={5}>
            <div className="sub-header-data-main">
              <div className="sub-header-location">
                <IoLocation color="#fff" size={24} />
                <p className="sub-header-data">
                  374 William S Canning Blvd, MA 2721, uae
                </p>
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
export default SubHeader;
